module.exports = Object.freeze({
  MODAL_BODY_TYPES: {
    USER_DETAIL: 'USER_DETAIL',
    VISIT_ADD_NEW: 'VISIT_ADD_NEW',
    VISIT_OVERVIEW: 'VISIT_OVERVIEW',
    VISIT_OVERVIEW_COMPANY: 'VISIT_OVERVIEW_COMPANY',
    VISIT_OVERVIEW_AFFILIATE: 'VISIT_OVERVIEW_AFFILIATE',
    VISIT_OVERVIEW_CANCELATION_MODAL: 'VISIT_OVERVIEW_CANCELATION_MODAL',
    VISIT_OVERVIEW_ACTIVATION_MODAL: 'VISIT_OVERVIEW_ACTIVATION_MODAL',
    VISIT_OVERVIEW_QUERY_MODAL: 'VISIT_OVERVIEW_QUERY_MODAL',
    VISIT_OVERVIEW_QUERY_RESOLVE_MODAL: 'VISIT_OVERVIEW_QUERY_RESOLVE_MODAL',
    VISIT_OVERVIEW_CHECKIN_MODAL: 'VISIT_OVERVIEW_CHECKIN_MODAL',
    REVIEW_ENROLLMENT: 'REVIEW_ENROLLMENT',
    PHYSICIAN_CHECKIN_MODAL: 'PHYSICIAN_CHECKIN_MODAL',
    CHAT_SNIPPETS_MODAL: 'CHAT_SNIPPETS_MODAL',
    RX_SNIPPETS_MODAL: 'RX_SNIPPETS_MODAL',
    CHAT_SNIPPETS_CREATE_MODAL: 'CHAT_SNIPPETS_CREATE_MODAL',
    RX_SNIPPETS_CREATE_MODAL: 'RX_SNIPPETS_CREATE_MODAL',
    RX_SNIPPETS_ASSIGN_MODAL: 'RX_SNIPPETS_ASSIGN_MODAL',
    SUPPORT_CHAT_SNIPPETS: 'SUPPORT_CHAT_SNIPPETS',
    SUPPORT_CHAT_STAFF: 'SUPPORT_CHAT_STAFF',
    PAST_VISIT_DETAIL: 'PAST_VISIT_DETAIL',
    PAST_VISIT_PATIENT_SELECT: 'PAST_VISIT_PATIENT_SELECT',
    RX_OBSERVED_DOSES_RESET: 'RX_OBSERVED_DOSES_RESET',
    PRESCRIPTION_HISTORY: 'PRESCRIPTION_HISTORY',
    PRESCRIPTION_PREFILL: 'PRESCRIPTION_PREFILL',
    UDS_LABTEST_INFO: 'UDS_LABTEST_INFO',
    UDS_HISTORY: 'UDS_HISTORY',
    CONFIRMATION: 'CONFIRMATION',
    DEFAULT: '',
  },

  RIGHT_DRAWER_TYPES: {
    NOTIFICATION: 'NOTIFICATION',
    VISIT_CHAT: 'VISIT_CHAT',
  },
  LEFT_DRAWER_TYPES: {
    VISIT_OVERVIEW: 'VISIT_OVERVIEW',
  },

  CONFIRMATION_MODAL_CLOSE_TYPES: {
    VISIT_ADD: 'VISIT_ADD',
    PASTVISIT_DELETE: 'PASTVISIT_DELETE',
    VISIT_COMPLETE: 'VISIT_COMPLETE',
  },

  ENROLLMENT_STATUS: {
    NULL: 'NULL',
    IN_PROGRESS: 'IN PROGRESS',
    ATTENTION: 'ATTENTION',
    COMPLETE: 'COMPLETE',
  },
  INTAKE_STATUS: {
    NULL: 'NULL',
    IN_PROGRESS: 'IN PROGRESS',
    ATTENTION: 'ATTENTION',
    COMPLETE: 'COMPLETE',
  },
  UDS_STATUS: {
    NULL: 'NULL',
    IN_PROGRESS: 'IN PROGRESS',
    ATTENTION: 'ATTENTION',
    COMPLETE: 'COMPLETE',
  },
  REVIEW_STATUS: {
    NULL: 'NULL',
    IN_PROGRESS: 'IN PROGRESS',
    WAITING_AFFILIATE: 'WAITING FOR AFFILIATE',
    COMPLETE: 'COMPLETE',
  },

  VIDEO_STATUS: {
    NULL: 'NULL',
    WAITING_ROOM: 'WAITING ROOM',
    WITH_PHYSICIAN: 'WITH PHYSICIAN',
    PENDING: 'PENDING',
    COMPLETE: 'COMPLETE',
  },

  VISIT_CANCELLATION_REASONS: {
    PATIENT_LEFT: 'Patient left',
    WRONG_PATIENT: 'Visit created for the wrong patient',
    MISTAKE: 'Visit created by mistake',
    DUPLICATE: 'This is a duplicate visit',
    NO_VISIT_REQUIRED: 'No visit required',
    OTHER: 'Other',
  },

  VISIT_QUERY_REASONS: {
    QUERY_REASON1: 'Prescription adjustment or addition',
    QUERY_REASON2: 'Prescription clarification',
    QUERY_REASON3: 'Patient wants to be seen again',  
    OTHER: 'Other',
  },

  // Lab test adulterant codes (standardized)
  // Note: Both 'CR' and 'CRE' are supported for Creatinine:
  // - 'CRE' is used by Btnx API
  // - 'CR' is kept for backward compatibility with existing data and manual entries
  ADULTERANT_CODES: ['CR', 'CRE', 'SG', 'pH'],

  // Default observation codes for lab tests
  DEFAULT_DRUG_OBSERVATION_CODES: ['POS', 'NEG', 'INV'],
  DEFAULT_ADULTERANT_OBSERVATION_CODES: ['NORM', 'ABN'],

  // Code aliases for backward compatibility (legacy code -> standard code)
  CODE_ALIASES: {
    BZO: 'BZD',
    MOP: 'MOR',
    HYD: 'HMO',
  },
})

// Helper function to check if a code is an adulterant (case-insensitive)
// Note: Both 'CR' and 'CRE' are supported for Creatinine:
// - 'CRE' is used by Btnx API
// - 'CR' is kept for backward compatibility with existing data and manual entries
const ADULTERANT_CODES_LIST = ['CR', 'CRE', 'SG', 'pH'];
function isAdulterantCode(code) {
  if (!code || typeof code !== 'string') return false;
  const normalizedCode = code.trim().toLowerCase();
  return ADULTERANT_CODES_LIST.some(c => c.toLowerCase() === normalizedCode);
}


const constants = module.exports;
module.exports = Object.assign({}, constants, { isAdulterantCode });
